import PropTypes from 'prop-types';
import React from 'react';
import { sanitizeTextWithHtml } from '../../shared/htmlSanitizer';

export class DangerousHTMLSpan extends React.Component {
  render() {
    return (
      <span data-qa-item={ this.props.qaTag }
        className={ this.props.className }
        dangerouslySetInnerHTML={ sanitizeTextWithHtml(this.props.html) }
      />
    );
  }
}

DangerousHTMLSpan.propTypes = {
  html: PropTypes.string,
  className: PropTypes.string,
  qaTag: PropTypes.string,
};
